import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './AdminDashboard.css'; // Reuse the same CSS file
import axiosInstance from './axiosInstance'; // Import the axios instance

const AdminLogout = ({ showNames }) => {
    const navigate = useNavigate();
    const [adminFirstName, setAdminFirstName] = useState('Admin');
    
    const handleLogout = async () => {
        try {
            const token = Cookies.get('token');
            if (!token) {
                console.error('No token found');
                return;
            }

            await axiosInstance.post('/admin/logout', {}, {
                headers: { Authorization: `Bearer ${token}` },
            });

            // Clear the token from cookies
            Cookies.remove('token');

            // Redirect to the login page
            navigate('/admin/login');
        } catch (error) {
            console.error('Failed to logout:', error);
        }
    };

    useEffect(() => {
        const fetchAdminFirstName = async () => {
            try {
                const response = await axiosInstance.get('/admin/first-name');
                setAdminFirstName(response.data.first_name);
            } catch (err) {
                console.error('Failed to fetch admin first name', err);
            }
        };

        fetchAdminFirstName();
    }, []);

    const cardStyle = {
        padding: '16px',
        borderRadius: '8px',
        backgroundColor: '#2d2d2d',
        color: 'white',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.3s, box-shadow 0.3s, border-color 0.3s',
        border: '2px solid #ff7c0a',
        textAlign: 'center',
    };

    const titleStyle = {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginTop: '16px',
        color: '#ff7c0a',
    };

    const buttonStyle = {
        backgroundColor: '#ff7c0a',
        color: 'white',
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        margin: '5px',
        fontWeight: 'semibold',
    };

    const cancelButtonStyle = {
        ...buttonStyle,
        backgroundColor: 'white',
        color: '#ff7c0a',
        fontWeight: 'semibold',
    };

    return (
        <div className={`admin-dashboard-container ${showNames ? 'show-names' : ''}`}>
            <div className="mini-header">
                <h1 className="mini-header-title">Admin Logout</h1>
                <div className="mini-header-right">
                    <span className="admin-name">{adminFirstName}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                        <path fill="currentColor" d="M23 9A7 7 0 1 1 9 9a7 7 0 0 1 14 0m-2 0a5 5 0 1 0-10 0a5 5 0 0 0 10 0M7.5 18A3.5 3.5 0 0 0 4 21.5v.5c0 2.393 1.523 4.417 3.685 5.793C9.859 29.177 12.802 30 16 30s6.14-.823 8.315-2.207C26.477 26.417 28 24.393 28 22v-.5a3.5 3.5 0 0 0-3.5-3.5zM6 21.5A1.5 1.5 0 0 1 7.5 20h17a1.5 1.5 0 0 1 1.5 1.5v.5c0 1.473-.94 2.949-2.759 4.106C21.434 27.256 18.877 28 16 28s-5.434-.744-7.241-1.894C6.939 24.95 6 23.472 6 22z" />
                    </svg>
                </div>
            </div>
            <div className="dashboard-container">
                <div className="dashboard-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ ...cardStyle, width: '300px' }}>
                        <h3 style={titleStyle}>Are you sure you want to logout?</h3>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <button style={buttonStyle} onClick={handleLogout}>Logout</button>
                            <button style={cancelButtonStyle} onClick={() => navigate('/admin')}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogout;